import { INTERACTION_TYPES, send } from './apopheniaLogger';

let hasLoggedOnce = false;

const ProfileViewLogger = (sendLog = send) => {
  if (!window.PRO_ACCOUNT_KEY || hasLoggedOnce) return;

  sendLog({
    screen_id: 'pro_profile_page',
    account_key: window.PRO_ACCOUNT_KEY,
    page_url: window.location.href,
    referral_key: window.localStorage.getItem('trusted:real_estate:rfid'),
    interaction_type: INTERACTION_TYPES.PAGE_VIEWED
  });

  hasLoggedOnce = true;
};

export const resetLogTracker = () => {
  hasLoggedOnce = false;
};

export default ProfileViewLogger;
